import {useField} from 'formik';

const TextAreaFormik = ({...props}: ITextAreaFormikProps) => {
  const [field, meta] = useField(props);
  return (
    <>
      <textarea
        className={
          meta.touched && meta.error
            ? 'py-2 px-2 w-full rounded-md focus:outline-none border-solid border border-red-400'
            : 'border-solid border border-gray-3 py-2 px-2 w-full rounded-md focus:outline-none'
        }
        {...field}
        rows={props.row}
        {...props}
      />
      {meta.touched && meta.error ? (
        <div className="pt-1 flex">
          <span className="icon-error mx-1 text-sm text-red-400"></span>
          <small>
            <p className=" text-red-400">{meta.error}</p>
          </small>
        </div>
      ) : null}
    </>
  );
};
export default TextAreaFormik;
